// extracted by mini-css-extract-plugin
export default {"form":"BasicForm_form__+XD03","basicForm":"BasicForm_basicForm__+qmrN","createButton":"BasicForm_createButton__7yilp","appear":"BasicForm_appear__ujkNB"};